/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_Key_LabelInputs */

const en_admin_indexnow_key_label = /** @type {(inputs: Admin_Indexnow_Key_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IndexNow API key`)
};

/**
* | output |
* | --- |
* | "IndexNow API key" |
*
* @param {Admin_Indexnow_Key_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_key_label = /** @type {((inputs?: Admin_Indexnow_Key_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Key_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_key_label(inputs)
});
export { admin_indexnow_key_label as "admin.indexnow.key_label" }